import parse from 'html-react-parser';
import { ChangeEventHandler, ReactNode } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface InputFieldProps {
  label?: string | ReactNode;
  unit?: string;
  value?: string | number;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  readOnly?: boolean;
  step?: string | number;
  name?: string;
  type?: string;
  placeholder?: string;
}

function InputField({ label, unit, value, onChange, readOnly, step, name, type, placeholder }: InputFieldProps) {
  return (
    <div>
      {label && (
        <Label className="font-medium text-foreground text-xs">
          {typeof label === 'string' ? parse(label) : label}
        </Label>
      )}
      <div className="flex">
        <Input
          type={type || "number"}
          lang="en"
          step={step ?? 0.1}
          name={name}
          value={value ?? ''}
          onChange={onChange}
          readOnly={readOnly}
          placeholder={placeholder}
          className={[
            unit ? "rounded-r-none" : "",
            readOnly ? "bg-muted font-medium text-foreground border-primary/40 cursor-default" : ""
          ].filter(Boolean).join(" ")}
        />
        {unit && (
          <span className="inline-flex items-center px-3 border border-l-0 border-input bg-muted text-muted-foreground text-sm rounded-r-md whitespace-nowrap">
            {unit}
          </span>
        )}
      </div>
    </div>
  );
}

export default InputField;
